import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as DownBracket } from "../Images/down_bracket.svg";
import LayoutCorporation from "../Layout/LayoutCorporation";
import Pagination from "../Layout/Pagination";
import OrderInfo from "../Modals/OrderInfo.jsx";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postCompanyJson, postJson } from "../Utils/apiUtils";

const SubscribeManage = () => {
  return (
    <LayoutCorporation page={<SubscribeManagePage />} thisPage="subscribe" />
  );
};

const SubscribeManagePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [planClicked, setPlanClicked] = useState(
    location.state?.gifticonClick ? false : true
  );
  const [gifticonClicked, setGifticonClicked] = useState(
    location.state?.gifticonClick
  );

  const [companyInfo, setCompanyInfo] = useState({
    limitUsers: null,
    planType: null,
    planStartTime: null,
    planEndTime: null,
  });
  const hasLoadedCompanyInfo = useRef(false);

  const [gifticonBoxClicked, setGifticonBoxClicked] = useState(
    location.state?.orderClick ? false : true
  );
  const [orderListClicked, setOrderListClicked] = useState(
    location.state?.orderClick
  );

  const handlePlanClick = () => {
    setGifticonClicked(false);
    setPlanClicked(true);
  };
  const handleGifticonClick = () => {
    setGifticonClicked(true);
    setPlanClicked(false);
  };

  const getCompanyInfo = async () => {
    try {
      const res = await postJson("/dashboard/company/getCompanyInfo", {}, navigate);

      if (res.code === 200) {
        setCompanyInfo({
          limitUsers: res.data.limitUsers,
          planType: res.data.planType,
          planStartTime: res.data.planStartTime,
          planEndTime: res.data.planEndTime,
        });
      }
    } catch (error) {
      console.error("기업 정보 가져오기 중 에러:", error);
    }
  };

  useEffect(() => {
    if (hasLoadedCompanyInfo.current) {
      return;
    }

    hasLoadedCompanyInfo.current = true;
    getCompanyInfo();
  }, []);

  return (
    <div>
      <div style={{ display: "flex", marginLeft: "180px", marginTop: "22px" }}>
        <div
          style={{
            color: planClicked ? "#1167ed" : "#222222",
            fontSize: "24px",
            fontFamily: "notoSans-bold",
            cursor: "pointer",
          }}
          onClick={handlePlanClick}
        >
          플랜 관리
        </div>
        <div
          style={{
            marginLeft: "22px",
            color: gifticonClicked ? "#1167ed" : "#222222",
            fontSize: "24px",
            fontFamily: "notoSans-bold",
            cursor: "pointer",
          }}
          onClick={handleGifticonClick}
        >
          기프티콘
        </div>
      </div>
      {/* <Wrapper style={{ width: "1500px" }}>
        <div className="grayBox">
          {payment_number !== null ? (
            ""
          ) : (
            <Wrapper style={{ width: "695px", marginBottom: "20px" }}>
              <IconInfo fill="#6d6d6d" />
              <div
                className="medium-18"
                style={{ marginLeft: "4px", color: "#6d6d6d" }}
              >
                원활한 정기 결제를 위해 결제 수단을 등록해주세요!
              </div>
            </Wrapper>
          )}

          <Wrapper>
            <div>
              <p className="medium-16" style={{ color: "#6d6d6d" }}>
                결제 예정일
              </p>
              <p className="medium-text" style={{ fontSize: "18px" }}>
                {paying_date}
              </p>
            </div>

            <div className="vert-line" />

            <div>
              <p className="medium-16" style={{ color: "#6d6d6d" }}>
                결제 수단
              </p>
              {payment_number !== null ? (
                <Wrapper style={{ marginTop: "3px" }}>
                  <div className="payType-box center">{payment_type}</div>
                  <p
                    className="medium-text"
                    style={{ fontSize: "18px", marginLeft: "4px" }}
                  >
                    {"["}
                    {payment_bank}
                    {"]"}
                    {payment_number}
                  </p>
                </Wrapper>
              ) : (
                <p className="medium-18" style={{ color: "#b0b0b0" }}>
                  등록한 결제 수단이 아직 없습니다.
                </p>
              )}
            </div>
          </Wrapper>
        </div>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <MoreBtn option1="결제 수단 관리" option2="구독 해지" />
        </div>
      </Wrapper> */}

      {/* <Wrapper style={{ marginTop: "20px", marginBottom: "20px" }}>
        <BtnBar>
          <div
            className={
              planClicked ? "btn-planorpayinfo blue" : "btn-planorpayinfo"
            }
            onClick={handlePlanClick}
          >
            플랜 정보
          </div>
          <div style={{ width: "14px" }}></div>
          <div
            className={
              payinfoClicked ? "btn-planorpayinfo blue" : "btn-planorpayinfo"
            }
            onClick={handlePayinfoClick}
          >
            결제 내역
          </div>
        </BtnBar>
      </Wrapper> */}

      {planClicked ? (
        <SubscribeBox>
          <Wrapper>
            <div>
              <PlanBox>
                <div style={{ display: "flex", width: "675px" }}>
                  <p className="bluebtn-plan center">현재 플랜</p>
                  <p style={{ color: "#1167ed", marginLeft: "auto" }}>
                    {/* 2024년 3월 4일부터 이용중 */}
                  </p>
                </div>

                <p
                  className="bold-text"
                  style={{ marginTop: "14px", fontSize: "24px" }}
                >
                  기업용 기본 플랜
                  {companyInfo.planType === 1 ? "(기간형)" : "(구독형)"}
                </p>

                <div style={{ display: "flex", marginTop: "14px" }}>
                  <p style={{ color: "#555555" }}>구성원 용량</p>
                  <p className="medium-text" style={{ marginLeft: "30px" }}>
                    {companyInfo.limitUsers?.toLocaleString()}명
                  </p>
                </div>
                {/* <div style={{ display: "flex", marginTop: "4px" }}>
              <p style={{ color: "#555555" }}>추가 서비스</p>
              {extraService_list.length > 0 ? (
                <p className="medium-text" style={{ marginLeft: "30px" }}>
                  기프티콘 플러스, 추가서비스명
                </p>
              ) : (
                <p className="medium-text" style={{ marginLeft: "30px" }}>
                  없음
                </p>
              )}
            </div> */}

                <hr className="hrz-line 14" color="#e4e4e4" />

                <div style={{ display: "flex" }}>
                  <p style={{ color: "#555555" }}>이용 기간</p>
                  <p style={{ marginLeft: "45px", color: "#222222" }}>
                    {companyInfo.planStartTime} ~ {companyInfo.planEndTime}
                  </p>
                </div>
              </PlanBox>

              {/* <BillList extraService_list={extraService_list} /> */}

              <p
                className="medium-text"
                style={{
                  marginTop: "20px",
                  fontSize: "14px",
                  color: "#888888",
                }}
              >
                · 구성원 1인당 이용료 : 1,500원
                <br />
                · 구성원 인원수 업그레이드 시 아래 문의처로 문의 바랍니다.
                <br />· 문의 : info@runpoint.co.kr
              </p>
            </div>

            {/* <div style={{ marginLeft: "30px" }}>
          <UpgradeMember />
          <div style={{ marginTop: "20px" }}>
            <UpgradeMember />
          </div>
        </div> */}
          </Wrapper>
        </SubscribeBox>
      ) : (
        <div
          style={{
            width: "1500px",
            borderRadius: "20px",
            padding: "30px",
            margin: "22px 0 40px 180px",
            backgroundColor: "#ffffff",
          }}
        >
          <div style={{ display: "flex" }}>
            <p
              className="medium-text"
              style={{
                fontSize: "18px",
                cursor: "pointer",
                color: gifticonBoxClicked ? "#1167ed" : "#8E96A0",
                paddingBottom: "15px",
                boxShadow: gifticonBoxClicked ? "inset 0 -2px 0 #1167ed" : "",
              }}
              onClick={() => {
                setGifticonBoxClicked(true);
                setOrderListClicked(false);
              }}
            >
              보관함
            </p>
            <p
              className="medium-text"
              style={{
                fontSize: "18px",
                marginLeft: "14px",
                cursor: "pointer",
                color: orderListClicked ? "#1167ed" : "#8E96A0",
                paddingBottom: "15px",
                boxShadow: orderListClicked ? "inset 0 -2px 0 #1167ed" : "",
              }}
              onClick={() => {
                setGifticonBoxClicked(false);
                setOrderListClicked(true);
              }}
            >
              주문 내역
            </p>
          </div>

          {gifticonBoxClicked ? <GifticonBox /> : <OrderList />}
        </div>
      )}
    </div>
  );
};

const GifticonBox = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const offset = 9;

  const [gifticon_list, setGifticon_list] = useState([]);
  const [isNext, setIsNext] = useState(0);
  const lastGifticonRequestKey = useRef(null);

  const getGifticonList = async () => {
    try {
      const res = await postJson(
        "/dashboard/gifticonChallenge/getGifticonList",
        { page, offset },
        navigate
      );

      if (res.code === 200) {
        setGifticon_list(res.data.rows);
        setIsNext(res.data.isNext);
      }
    } catch (error) {
      console.error("기프티콘 리스트 가져오기 중 에러:", error);
    }
  };

  useEffect(() => {
    const requestKey = JSON.stringify({ page });

    if (lastGifticonRequestKey.current === requestKey) {
      return;
    }

    lastGifticonRequestKey.current = requestKey;
    getGifticonList();
  }, [page]);

  return (
    <div>
      <p style={{ marginTop: "24px", marginBottom: "14px" }}>
        전체 {gifticon_list.length?.toLocaleString()}건
      </p>
      <div
        className="list_titleBar"
        style={{ gridTemplateColumns: "44px 430px 1026px" }}
      >
        <div />
        <p className="leftalign medium-14" style={{ color: "#888888" }}>
          기프티콘
        </p>
        <p className="leftalign medium-14" style={{ color: "#888888" }}>
          보유 갯수
        </p>
      </div>
      {gifticon_list.slice(0, 10).map((data) => (
        <GifticonItem
          key={data.orderItemId}
          goodsImgS={data.goodsImgS}
          goodsName={data.goodsName}
          availableCount={data.availableCount}
          goodsStateCd={data.goodsStateCd}
        />
      ))}

      <Pagination
        totalPages={
          gifticon_list.length === 0 ? 1 : Math.ceil(gifticon_list.length / 9)
        }
        currentPage={page}
        onPageChange={(pageNum) => setPage(pageNum)}
      />
      <p className="medium-14" style={{ marginTop: "30px", color: "#888888" }}>
        · 구매한 기프티콘은 1년 이내로 사용해야 합니다. 1년이 지난 후 구매
        날짜를 기준으로 순차적으로 소멸됩니다. <br />
        · 주기적인 업데이트로 상품 정보가 바뀔 가능성이 있습니다. <br />
        · 구매한 상품이 판매중지되어 사용이 불가능해진 경우 환불 또는 상품을
        변경해드립니다. 랭킹마라톤에 문의해주세요. <br />· 문의:
        info@runpoint.co.kr
      </p>
    </div>
  );
};

const GifticonItem = ({
  goodsImgS,
  goodsName,
  availableCount,
  goodsStateCd,
}) => {
  const [goodsAvailable, setGoodsAvailable] = useState(true);
  const checkGoodsState = () => {
    if (goodsStateCd === "SALE") setGoodsAvailable(true);
    else if (goodsStateCd === "SUS") setGoodsAvailable(false);
  };

  useEffect(() => {
    checkGoodsState();
  }, []);
  return (
    <div
      className="list_contentBar"
      style={{ gridTemplateColumns: "44px 430px 990px 36px" }}
    >
      <div className="center">
        <div style={{ width: "44px", height: "44px" }}>
          <img src={goodsImgS} style={{ width: "100%", height: "100%" }} />
        </div>
      </div>
      <div className="leftalign">
        {!goodsAvailable && (
          <div
            className="center"
            style={{
              width: "72px",
              height: "36px",
              borderRadius: "8px",
              backgroundColor: "#fde7e7",
              color: "#f25c5c",
              fontSize: "14px",
              fontFamily: "notoSans-medium",
            }}
          >
            판매중지
          </div>
        )}
        <p
          style={{
            color: goodsAvailable ? "#222222" : "#888888",
            marginLeft: goodsAvailable ? "" : "10px",
          }}
        >
          {goodsName}
        </p>
      </div>
      <p
        className="leftalign medium-text"
        style={{ color: goodsAvailable ? "#1167ed" : "#b0b0b0" }}
      >
        {availableCount?.toLocaleString()}개
      </p>
      <p className="leftalign"></p>
    </div>
  );
};

const OrderList = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const offset = 9;

  const [clickDetail, setClickDetail] = useState(false);
  const [clickedId, setClickedId] = useState(0);

  const [timeState, setTimeState] = useState({ startTime: "", endTime: "" });
  const [order_list, setOrder_list] = useState([]);
  const [total_order, setTotal_order] = useState(0);
  const lastOrderRequestKey = useRef(null);

  const getFormattedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const periodOptionChange = (value) => {
    const today = new Date();
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);

    const oneMonthAgo = new Date(today);
    oneMonthAgo.setDate(today.getMonth() - 1);

    const threeMonthAgo = new Date(today);
    threeMonthAgo.setDate(today.getMonth() - 3);

    const sixMonthAgo = new Date(today);
    sixMonthAgo.setDate(today.getMonth() - 6);

    if (value === "전체") setTimeState({ startTime: "", endTime: "" });
    else if (value === "1주일")
      setTimeState({
        startTime: getFormattedDate(oneWeekAgo),
        endTime: getFormattedDate(today),
      });
    else if (value === "1개월")
      setTimeState({
        startTime: getFormattedDate(oneMonthAgo),
        endTime: getFormattedDate(today),
      });
    else if (value === "3개월")
      setTimeState({
        startTime: getFormattedDate(threeMonthAgo),
        endTime: getFormattedDate(today),
      });
    else if (value === "6개월")
      setTimeState({
        startTime: getFormattedDate(sixMonthAgo),
        endTime: getFormattedDate(today),
      });
    else setTimeState({ startTime: "", endTime: "" });
  };

  const handleClickDetail = (paymentId) => {
    setClickDetail(true);
    setClickedId(paymentId);
  };

  const getOrderList = async () => {
    try {
      const body = {
        page,
        offset,
        startTime: timeState.startTime,
        endTime: timeState.endTime,
      };

      const res = await postJson("/dashboard/gifticonOrder/getList", body, navigate);

      if (res.code === 200) {
        setOrder_list(res.data.rows);
        setTotal_order(res.data.count);
      }
    } catch (error) {
      console.error("주문 리스트 가져오기 중 에러:", error);
    }
  };

  useEffect(() => {
    const requestKey = JSON.stringify({
      page,
      startTime: timeState.startTime,
      endTime: timeState.endTime,
    });

    if (lastOrderRequestKey.current === requestKey) {
      return;
    }

    lastOrderRequestKey.current = requestKey;
    getOrderList();
  }, [page, timeState]);

  return (
    <div>
      {clickDetail && (
        <OrderInfo
          handleClickX={() => setClickDetail(false)}
          paymentId={clickedId}
        />
      )}
      <div className="hrz-wrapper">
        <p style={{ marginTop: "24px", marginBottom: "14px" }}>
          전체 {total_order?.toLocaleString()}건
        </p>
        <div style={{ marginLeft: "auto" }}>
          <PeriodOptionOrder optionChange={periodOptionChange} />
        </div>
      </div>
      <div
        className="list_titleBar"
        style={{
          gridTemplateColumns: "100px 230px 230px 300px 140px 140px 360px",
        }}
      >
        <p className="center">NO</p>
        <p className="leftalign">주문번호</p>
        <p className="leftalign">주문 일시</p>
        <p className="leftalign">상품명</p>
        <p className="leftalign">총 주문 금액</p>
        <p className="leftalign">결제 수단</p>
        <p className="leftalign">주문 상태</p>
      </div>
      {order_list.slice(0, 10).map((data) => (
        <OrderItem
          key={data.rownum}
          rownum={data.rownum}
          orderId={data.orderId}
          regTime={data.regTime}
          productName={data.productName}
          amount={data.amount}
          payMethod={data.payMethod}
          paymentId={data.paymentId}
          orderStatus={data.orderStatus}
          handleClickDetail={handleClickDetail}
        />
      ))}

      <Pagination
        totalPages={
          order_list.length === 0 ? 1 : Math.ceil(order_list.length / 9)
        }
        currentPage={page}
        onPageChange={(pageNum) => setPage(pageNum)}
      />
      <p className="medium-14" style={{ marginTop: "30px", color: "#888888" }}>
        · 무통장입금 주문 후 72시간 내 미입금 시 주문이 자동으로 취소됩니다.{" "}
        <br />· 주문한 수량중 1개 이상의 상품을 소진(발급)되었을 경우 환불요청이
        불가능합니다.
        <br /> · 환불 금액은 5 영업일 이내에 환불 계좌로 입금됩니다. <br />·
        문의: info@runpoint.co.kr
      </p>
    </div>
  );
};

const OrderItem = ({
  rownum,
  orderId,
  regTime,
  productName,
  amount,
  payMethod,
  paymentId,
  orderStatus,
  handleClickDetail,
}) => {
  const [_payMethod, set_payMethod] = useState("");
  const convertPayMethod = () => {
    if (payMethod === "trans") set_payMethod("무통장입금");
    else if (payMethod === "card") set_payMethod("신용카드");
    else if (payMethod === "vbank") set_payMethod("가상계좌");
  };
  useEffect(() => {
    convertPayMethod();
  }, []);

  return (
    <div
      className="list_contentBar"
      style={{
        gridTemplateColumns: "100px 230px 230px 300px 140px 140px 288px 72px",
      }}
    >
      <p className="center">{rownum}</p>
      <div className="leftalign scrollName">
        <p style={{ whiteSpace: "nowrap" }}>{orderId}</p>
      </div>
      <p className="leftalign">{regTime}</p>
      <div className="leftalign scrollName">
        <p style={{ whiteSpace: "nowrap" }}>{productName}</p>
      </div>
      <p className="leftalign">{amount?.toLocaleString()}원</p>
      <p className="leftalign">{_payMethod}</p>
      <p className="leftalign">{orderStatus}</p>
      <div className="center">
        <div
          style={{
            width: "72px",
            height: "36px",
            borderRadius: "8px",
            backgroundColor: "#f5f5f5",
          }}
          className="center"
          onClick={() => handleClickDetail(paymentId)}
        >
          <p
            className="medium-text"
            style={{ color: "#929292", fontSize: "14px" }}
          >
            주문상세
          </p>
        </div>
      </div>
    </div>
  );
};

const PeriodOptionOrder = ({ optionChange }) => {
  const [selectedOption, setSelectedOption] = useState("전체");

  const handleOptionChange = (value) => {
    setSelectedOption(value);
    optionChange(value);
  };
  return (
    <OptionBox>
      {["전체", "1주일", "1개월", "3개월", "6개월"].map((option) => (
        <OptionBtn
          key={option}
          $isSelected={selectedOption === option}
          onClick={() => handleOptionChange(option)}
        >
          {option}
        </OptionBtn>
      ))}
    </OptionBox>
  );
};

const OptionBox = styled.div`
  width: auto;
  height: 44px;
  border-radius: 12px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OptionBtn = styled.div`
  width: auto;
  height: auto;
  padding: 8px 10px;
  border-radius: 8px;
  margin-left: 2px;
  margin-right: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: "notoSans-medium";
  color: ${({ $isSelected }) => ($isSelected ? "#222222" : "#757575")};
  background-color: ${({ $isSelected }) =>
    $isSelected ? "#ffffff" : "#f5f5f5"};
  margin-left: 4px;
  cursor: pointer;
`;

// const BillList = ({ extraService_list }) => {
//   let total_price = "00,000";
//   let plan1_name = "플랜명";
//   let plan1_price = "2,200";
//   let member_count = "103";
//   let plan_price = "00,000";
//   return (
//     <BillBox>
//       <Wrapper>
//         <p style={{ color: "#555555" }}>이용 플랜</p>
//         <p className="medium-text" style={{ marginLeft: "45px" }}>
//           {plan1_name} 1인 {plan1_price}원 X {member_count}명
//         </p>
//         <p className="medium-text" style={{ marginLeft: "auto" }}>
//           {plan_price}원/월
//         </p>
//       </Wrapper>

//       {extraService_list.length > 0 ? (
//         <Wrapper>
//           <p style={{ color: "#555555", marginTop: "4px" }}>추가 서비스</p>
//           <div style={{ width: "568px", marginLeft: "30px" }}>
//             {extraService_list.map((data) => (
//               <ExtraService
//                 name={data.name}
//                 price={data.price}
//                 member={member_count}
//               />
//             ))}
//           </div>
//         </Wrapper>
//       ) : (
//         ""
//       )}

//       <hr className="hrz-line 14" color="#e4e4e4" />

//       <Wrapper>
//         <p
//           style={{
//             marginLeft: "auto",
//             fontSize: "14px",
//             color: "#6d6d6d",
//           }}
//         >
//           VAT 포함
//         </p>
//       </Wrapper>

//       <Wrapper>
//         <p className="bold-text" style={{ fontSize: "18px" }}>
//           정기 결제 금액
//         </p>
//         <p
//           className="bold-text"
//           style={{ fontSize: "18px", marginLeft: "auto" }}
//         >
//           {total_price}원/월
//         </p>
//       </Wrapper>
//     </BillBox>
//   );
// };

const ExtraService = ({ name, price, member }) => {
  return (
    <Wrapper style={{ marginTop: "4px" }}>
      <p className="medium-text" style={{}}>
        {name} 1인 {price}원 X {member}명
      </p>
      <p className="medium-text" style={{ marginLeft: "auto" }}>
        00,000원/월
      </p>
    </Wrapper>
  );
};

const UpgradeMember = () => {
  return (
    <UpgradeBox>
      <div style={{ width: "602px" }}>
        <p className="bold-text" style={{ fontSize: "24px" }}>
          구성원 업그레이드
        </p>
        <p style={{ marginTop: "4px" }}>
          승인 대기중인 구성원을 위해 구성원 용량을 늘려보세요.
        </p>
      </div>

      <div style={{ display: "flex", cursor: "pointer" }}>
        <p className="medium-text" style={{ color: "#1167ed" }}>
          펼치기
        </p>
        <div style={{ width: "4px" }} />
        <DownBracket stroke="#1167ed" />
      </div>
    </UpgradeBox>
  );
};

const SubscribeBox = styled.div`
  width: 1500px;
  height: auto;
  min-height: 634px;

  border-radius: 20px;
  padding: 30px;
  margin: 22px 0 40px 180px;
  background-color: #ffffff;
  .medium-18 {
    font-family: "notoSans-medium";
    font-size: 18px;
  }
  .medium-16 {
    font-family: "notoSans-medium";
    font-size: 16px;
  }
  .medium-14 {
    font-family: "notoSans-medium";
    font-size: 14px;
  }
  .vert-line {
    border-left: 1px solid #e4e4e4;
    height: 53px;
    margin-left: 30px;
    margin-right: 30px;
  }

  .hrz-line.14 {
    margin-top: 14px;
    margin-bottom: 14px;
  }

  .payType-box {
    width: 57px;
    height: 25px;
    border-radius: 4px;
    box-shadow: inset 0 0 0 1px #b0b0b0;
    font-family: "notoSans-medium";
    font-size: 12px;
    color: #6d6d6d;
  }
`;

const BtnBar = styled.div`
  width: 1500px;
  height: auto;
  display: flex;
  .btn-planorpayinfo {
    width: 71px;
    height: 56px;
    font-family: "notoSans-medium";
    font-size: 18px;
    color: #8e96a0;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .btn-planorpayinfo.blue {
    color: #1167ed;
    box-shadow: inset 0 -2px 0 0 #1167ed;
  }
`;

const PlanBox = styled.div`
  width: auto;
  height: auto;
  padding: 30px;
  border-radius: 20px;
  box-shadow: inset 0 0 0 2px #1167ed;
  .bluebtn-plan {
    width: 83px;
    height: 39px;
    border-radius: 6px;
    background-color: #dbe8fd;
    font-family: "notoSans-medium";
    color: #1167ed;
  }
`;

const BillBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  padding: 30px;
  background-color: #f5f5f5;
  margin-top: 20px;
  .hrz-billList {
  }
`;

const UpgradeBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  padding: 30px;
  background-color: #dce8fd;
  color: #222222;
  display: flex;
`;

const Wrapper = styled.div`
  display: flex;
`;

export default SubscribeManage;
